document.addEventListener("DOMContentLoaded", function () {
    const maintenancePopup = document.querySelector('.maintance-mode__popup');
    const passwordForm = document.getElementById('maintenance-popup-modal-password-form');
    const passwordInput = passwordForm.querySelector('input[type="password"]');
    const errorMessage = passwordForm.querySelector('.error-message');
    const passwordModal = document.querySelector('#MaintancePassword');

    if (localStorage.getItem('maintenanceModeDismissed')) {
        maintenancePopup.classList.add('hide');
    } else {
        maintenancePopup.style.display = 'flex';
        document.body.style.overflow = "hidden";
    }

    passwordForm.addEventListener('submit', function (event) {
        event.preventDefault();
        const enteredPassword = passwordInput.value;

        fetch('/apps/subscriptions-bat/authenticate-maintenance-modal', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                password: enteredPassword
            })
        }).then((response) => response.json()).then((data) => {
            if (data.ok) {
                localStorage.setItem('maintenanceModeDismissed', 'true');
                maintenancePopup.classList.add('hide');
                passwordModal.style.display = 'none';
                document.body.style.overflow = 'auto';
                document.body.classList.remove("popup-active");

                return
            }

            passwordInput.value = '';
            errorMessage.style.display = 'block';
            passwordInput.parentElement.classList.add('error');
        });
    });

    passwordInput.addEventListener('input', function () {
        if (passwordInput.parentElement.classList.contains('error')) {
            passwordInput.parentElement.classList.remove('error');
            errorMessage.style.display = 'none';
            errorMessage.textContent = '';
        }
    });
});
